<template>
	<div class="by-curriculum-body">
		<ul class="by-curriculum-content">
			<byCurriculumItem v-for="(item,index) in list" :key="index" :itemData="item"></byCurriculumItem>
		</ul>
		
		<el-pagination
				class="page pageNews"	
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="current"
				:page-size="size"
				layout="total, prev, pager, next"
				:total="total">
		</el-pagination>
	</div>
</template>

<script>
/**
 * 描述
 * @description 描述
 * @property {String}
 * @example <aby-botton-line  />
 */
import byCurriculumItem from "@/components/item/curriculum_1.vue"
export default {
	components: {
		// 引入组件
		byCurriculumItem
	},
	props: {
		
	},
	data() {
		return {
			current:1,
			size:10,
			total:0,
			list: []
		};
	},
	computed: {},
	created(obj) {
		// 页面第一次加载执行，参数为上个页面传递的数据，参数类型为Object
		this.getCourse()
	},
	methods: {
		// 获取在线课程
		getCourse(){
			let reqInfo = {};
			reqInfo.current = this.current;
			reqInfo.size = this.size;
			this.$api.Home.getCourse(reqInfo,res => {
				let resData = res.data.records;
			  this.list = resData
				this.total = res.data.total
			},err=>{
				console.log(err)
			})
		},
		handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			this.current = val
			this.getTrain()
		}
	},
	watch: {
		obj: {
			//监听的对象
			deep: true, //深度监听设置为 true
			handler: function(newV, oldV) {
				console.log('watch中：', newV);
			}
		}
	}
};
</script>

<style scoped></style>
